(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-custom-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initKft2Accordions() {

    // ── 1. Top-level mobile accordion (nav section headings) ─────────────
    document.querySelectorAll('.kft2-nav-heading').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        var nav = btn.nextElementSibling;
        if (nav && nav.classList.contains('kft2-nav')) {
          nav.classList.toggle('kft2-nav--open', !isOpen);
        }
      });
    });

    // ── 2. Nested sub-nav buttons (mobile accordion + desktop dropdown) ──
    document.querySelectorAll('.kft2-subnav-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        // Close any sibling open sub-navs in the same parent container
        var scope = btn.closest('.kft2-nav, .kft2-more-panel');
        if (scope) {
          scope.querySelectorAll('.kft2-subnav-btn[aria-expanded="true"]').forEach(function (other) {
            if (other !== btn) {
              other.setAttribute('aria-expanded', 'false');
              var s = other.nextElementSibling;
              if (s && s.classList.contains('kft2-subnav')) {
                s.classList.remove('kft2-subnav--open');
              }
            }
          });
        }
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        var subnav = btn.nextElementSibling;
        if (subnav && subnav.classList.contains('kft2-subnav')) {
          subnav.classList.toggle('kft2-subnav--open', !isOpen);
        }
      });
    });

    // ── 3. "View more" inline expand toggle ──────────────────────────────
    document.querySelectorAll('.kft2-more-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var opening = !isOpen;
        btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        var panel = btn.nextElementSibling;
        if (panel && panel.classList.contains('kft2-more-panel')) {
          panel.classList.toggle('kft2-more-panel--open', opening);
        }
        // Flip button label
        var textEl = btn.querySelector('.kft2-more-btn__text');
        if (textEl) {
          textEl.textContent = opening
            ? (btn.dataset.labelLess || 'Show less')
            : (btn.dataset.labelMore || '+ more');
        }
      });
    });

    // ── 4. Close sub-nav dropdowns on outside click ───────────────────────
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.kft2-subnav-group')) {
        document.querySelectorAll('.kft2-subnav-btn[aria-expanded="true"]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var s = btn.nextElementSibling;
          if (s && s.classList.contains('kft2-subnav')) {
            s.classList.remove('kft2-subnav--open');
          }
        });
      }
    });

    // ── 5. Close / restore on Escape key ─────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.kft2-subnav-btn[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var s = btn.nextElementSibling;
        if (s) s.classList.remove('kft2-subnav--open');
      });
      // "View more" is inline so no need to close on outside click,
      // but Escape still collapses it and restores label
      document.querySelectorAll('.kft2-more-btn[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var p = btn.nextElementSibling;
        if (p) p.classList.remove('kft2-more-panel--open');
        var textEl = btn.querySelector('.kft2-more-btn__text');
        if (textEl && btn.dataset.labelMore) textEl.textContent = btn.dataset.labelMore;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKft2Accordions);
  } else {
    initKft2Accordions();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebula-mega-menu"] && !Shopify.designMode) return;
  try {
    
  {
    const menuTriggers = document.querySelectorAll('[data-menu-trigger]');
    const menuItems = document.querySelectorAll('.zenith_menu_item');
    let currentOpenItem = null;
    let isMobile = false;

    // Detect mobile
    function updateMobileStatus() {
      isMobile = window.innerWidth < 768;
    }

    // Initialize
    function init() {
      updateMobileStatus();
      attachEventListeners();
    }

    function attachEventListeners() {
      menuTriggers.forEach(trigger => {
        const hasSubmenu = trigger.getAttribute('aria-expanded') !== null;

        if (!hasSubmenu) return;

        if (isMobile) {
          trigger.addEventListener('click', handleMobileMenuClick);
        } else {
          trigger.addEventListener('click', handleDesktopMenuClick);
          const menuItem = trigger.closest('.zenith_menu_item');
          menuItem.addEventListener('mouseenter', handleDesktopHover);
          menuItem.addEventListener('mouseleave', handleDesktopHoverOut);
        }

        // Keyboard navigation
        trigger.addEventListener('keydown', handleKeydown);
      });
    }

    function handleMobileMenuClick(e) {
      e.preventDefault();
      const trigger = e.currentTarget;
      const menuItem = trigger.closest('.zenith_menu_item');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (currentOpenItem && currentOpenItem !== menuItem) {
        closeMenu(currentOpenItem);
      }

      if (isExpanded) {
        closeMenu(menuItem);
      } else {
        openMenu(menuItem);
      }
    }

    function handleDesktopMenuClick(e) {
      // On desktop, if the menu item has a link and submenu,
      // we allow the link to work OR open the menu.
      // This version prioritizes opening the menu on click.
      if (e.currentTarget.getAttribute('aria-expanded') !== null) {
        e.preventDefault();
      }
    }

    function handleDesktopHover(e) {
      const menuItem = e.currentTarget;
      const trigger = menuItem.querySelector('[data-menu-trigger]');
      if (trigger.getAttribute('aria-expanded') !== null) {
        openMenu(menuItem);
      }
    }

    function handleDesktopHoverOut(e) {
      const menuItem = e.currentTarget;
      const trigger = menuItem.querySelector('[data-menu-trigger]');
      if (trigger.getAttribute('aria-expanded') !== null) {
        // Small delay to avoid flickering
        setTimeout(() => {
          if (!menuItem.matches(':hover')) {
            closeMenu(menuItem);
          }
        }, 50);
      }
    }

    function handleKeydown(e) {
      const trigger = e.currentTarget;
      const menuItem = trigger.closest('.zenith_menu_item');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isMobile) {
            if (isExpanded) {
              closeMenu(menuItem);
            } else {
              openMenu(menuItem);
            }
          }
          break;
        case 'Escape':
          if (isExpanded) {
            closeMenu(menuItem);
            trigger.focus();
          }
          break;
        case 'ArrowDown':
          if (!isExpanded && isMobile) {
            e.preventDefault();
            openMenu(menuItem);
          }
          break;
        case 'ArrowRight':
          if (!isExpanded) {
            e.preventDefault();
            openMenu(menuItem);
          }
          break;
        case 'ArrowLeft':
          if (isExpanded) {
            e.preventDefault();
            closeMenu(menuItem);
          }
          break;
      }
    }

    function openMenu(menuItem) {
      const trigger = menuItem.querySelector('[data-menu-trigger]');
      trigger.setAttribute('aria-expanded', 'true');
      menuItem.classList.add('nebula_active');
      currentOpenItem = menuItem;
    }

    function closeMenu(menuItem) {
      const trigger = menuItem.querySelector('[data-menu-trigger]');
      trigger.setAttribute('aria-expanded', 'false');
      menuItem.classList.remove('nebula_active');
      if (currentOpenItem === menuItem) {
        currentOpenItem = null;
      }
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      const wasDesktop = !isMobile;
      updateMobileStatus();

      // If switching from desktop to mobile, close any open menus
      if (wasDesktop && isMobile && currentOpenItem) {
        closeMenu(currentOpenItem);
      }

      // Re-attach listeners with correct handlers
      attachEventListeners();
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (
        !e.target.closest('.zenith_menu_item') &&
        currentOpenItem
      ) {
        closeMenu(currentOpenItem);
      }
    });

    // Initialize on load
    init();
  }

  } catch(e) { console.error(e); }
})();
})();
